
//Cards
export const SCORE_VALUE_CARD: number = 15;
export const SCORE_ROCK_CARD: number = 0;
export const SCORE_BOOM_CARD: number = 100;
export const SCORE_BOOM_TARGET_CARD: number = 100;
export const SCORE_SCISSOR_CARD: number = 0;
export const SCORE_LOCK_CARD: number = 50;
export const SCORE_PLUS_THREE_CARD: number = 0;
export const SCORE_PLUS_THREE_NEW_CARD: number = 0;
export const SCORE_TORNADO_CARD: number = 0;
export const SCORE_TORNADO_TARGET_CARD: number = 0;
export const SCORE_GOLD_CARD: number = 0;
export const SCORE_SCYTHE_CARD: number = 100;
export const SCORE_SCYTHE_TARGET_CARD: number = 100;

// Modifiers
export const SCORE_PICKAXE_CARD: number = 0;
export const SCORE_ROPE_CARD: number = 0;
export const SCORE_KEY_CARD: number = 0;
export const SCORE_BOMB_CARD: number = 150; // Tomato bomb
export const SCORE_FOG_CARD: number = 0;
export const SCORE_ICE_CARD: number = 0;
export const SCORE_RISING_CARD: number = 0;
export const SCORE_LOWERING_CARD: number = 0;
export const SCORE_CONNECTED_CARD: number = 0;

// Boosters
export const SCORE_JOKER_BOOSTER: number = SCORE_VALUE_CARD;
export const SCORE_BULLSEYE_BOOSTER: number = SCORE_VALUE_CARD;
export const SCORE_TNT_BOOSTER: number = SCORE_VALUE_CARD;
export const SCORE_JOKER_PRE_BOOSTER: number = 0;
export const SCORE_CANISTER_PRE_BOOSTER: number = 0;
